import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

export const ChevronForwardIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1.6} sizeIsHeight={true} {...props} viewBox="0 0 14 26" ratio={14 / 26}>
            <path
                d="M13.6553 13.252C14.0263 12.881 14.0263 12.2706 13.6553 11.8996L2.16583 0.410098C1.79482 0.0390832 1.18444 0.0390833 0.81342 0.410098C0.442405 0.781114 0.442405 1.39149 0.81342 1.76251L11.6267 12.5758L0.813422 23.3891C0.442407 23.7601 0.442407 24.3705 0.813422 24.7415C1.18444 25.1125 1.79482 25.1125 2.16583 24.7415L13.6553 13.252Z"
                fill={props.color? props.color: "currentColor"}/>

        </SvgIcon>
    );
}
